export const LP_MIN_THRESHOLD = 0.01;

type RowWithLp = { primaryKey: string; lp: number; asIsLp: number };

export const findZeroLpViolations = <T extends RowWithLp>(
  rows: T[],
  baseline: Map<string, RowWithLp>,
): T[] =>
  rows.filter(
    (row) =>
      row.lp < LP_MIN_THRESHOLD &&
      (baseline.get(row.primaryKey)?.asIsLp ?? 0) > 0,
  );
